import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { CartContext } from '../CartProvider';

export function CheckoutAddress() {
  const navigate = useNavigate();
  const { shippingAddress, setShippingAddress, mailAddress, setMailAddress, differentBillingAddress, setDifferentBillingAddress } = useContext(CartContext);

  const [email, setEmail] = useState(mailAddress || '');
  const [firstName, setFirstName] = useState(shippingAddress?.firstName || '');
  const [lastName, setLastName] = useState(shippingAddress?.lastName || '');
  const [companyName, setCompanyName] = useState(shippingAddress?.company || '');
  const [addressLine1, setAddressLine1] = useState(shippingAddress?.addressLine1 || '');
  const [zip, setZip] = useState(shippingAddress?.zip || '');
  const [city, setCity] = useState(shippingAddress?.city || '');
  const [country, setCountry] = useState('Deutschland');
  const [differentBilling, setDifferentBilling] = useState(differentBillingAddress || false);

  const isFormValid = () => {
    const zipValid = /^\d{5}$/.test(zip);
    return email && firstName && lastName && addressLine1 && zipValid && city;
  };

  const handleContinue = () => {
    setShippingAddress({
      firstName: firstName,
      lastName: lastName,
      company: companyName,
      addressLine1: addressLine1,
      addressLine2: '',
      zip: zip,
      city: city,
      country: country
    });
    setDifferentBillingAddress(differentBilling);
    setMailAddress(email);

    if (differentBilling) {
      navigate('/checkoutBillingAddress');
    } else {
      navigate('/checkoutSummary');
    };
  }

  const handleBack = () => {
    navigate(-1);
  }

  return (
    <div style={{ marginBottom: '60px' }}>
      <h1 style={{ marginBottom: '40px' }}>Lieferadresse</h1>
      <div style={{ marginTop: '10px', width: '100%', maxWidth: '620px' }}>
        <label htmlFor="inputMail" style={{ display: 'block' }}>E-Mail*</label>
        <input 
          id="inputMail" 
          type="email" 
          value={email} 
          onChange={(e) => setEmail(e.target.value)}
          style={{ width: '100%', maxWidth: '620px', boxSizing: 'border-box' }} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', maxWidth: '620px' }}>
        <div style={{ flex: '0 0 47%', marginRight: '3%' }}>
          <label htmlFor="inputShippingFirstname" style={{ display: 'block' }}>Vorname*</label>
          <input
            id="inputShippingFirstname"
            type="text"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            style={{ width: '100%', maxWidth: '300px', boxSizing: 'border-box' }}
          />
        </div>
        <div style={{ flex: '0 0 47%', marginLeft: '3%' }}>
          <label htmlFor="inputShippingLastname" style={{ display: 'block' }}>Nachname*</label>
          <input
            id="inputShippingLastname"
            type="text"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            style={{ width: '100%', maxWidth: '300px', boxSizing: 'border-box' }}
          />
        </div>
      </div>
      <div style={{ marginTop: '10px', width: '100%', maxWidth: '620px' }}>
        <label htmlFor="inputCompanyName" style={{ display: 'block' }}>Firmenname</label>
        <input
          id="inputCompanyName"
          type="text"
          value={companyName}
          onChange={(e) => setCompanyName(e.target.value)}
          style={{ width: '100%', maxWidth: '620px', boxSizing: 'border-box' }}
        />
      </div>
      <div style={{ marginTop: '10px', width: '100%', maxWidth: '620px' }}>
        <label htmlFor="inputAddressLine1" style={{ display: 'block' }}>Strasse und Hausnummer*</label>
        <input
          id="inputAddressLine1"
          type="text"
          value={addressLine1}
          onChange={(e) => setAddressLine1(e.target.value)}
          style={{ width: '100%', maxWidth: '620px', boxSizing: 'border-box' }}
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', maxWidth: '620px' }}>  
        <div style={{ marginTop: '10px', flex: '0 0 27%', marginRight: '3%' }}>
          <label htmlFor="inputZip" style={{ display: 'block' }}>Postleitzahl*</label>
          <input
            id="inputZip"
            type="text"
            value={zip}
            onChange={(e) => setZip(e.target.value)}
            style={{ width: '100%', maxWidth: '200px', boxSizing: 'border-box' }}
          />
        </div>
        <div style={{ marginTop: '10px', flex: '0 0 67%', marginRight: '3%' }}>
          <label htmlFor="inputCity" style={{ display: 'block' }}>Ort*</label>
          <input
            id="inputCity"
            type="text"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            style={{ width: '100%', maxWidth: '400px', boxSizing: 'border-box' }}
          />
        </div>
      </div>
      <div style={{ marginTop: '10px', width: '100%', maxWidth: '620px' }}>
        <label htmlFor="inputCountry" style={{ display: 'block' }}>Land*</label>
        <input
          id="inputCountry"
          type="text"
          value={country}
          style={{ width: '100%', maxWidth: '620px', boxSizing: 'border-box' }}
          disabled
        />
      </div>
      <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center' }}>
        <input
          id="inputDifferentBilling"
          type="checkbox"
          checked={differentBilling}
          onChange={(e) => setDifferentBilling(e.target.checked)}
        />
        <label htmlFor="inputDifferentBilling" style={{ display: 'block', marginLeft: '5px' }}>Abweichende Rechnungsadresse</label>
      </div>
      <div style={{ marginTop: '20px', marginBottom: '8px', fontFamily: "'Inter', sans-serif", fontSize: '12px', color: '#B0ADA7' }}>* erforderliche Felder</div>
      <div style={{ marginTop: '28px', marginBottom: '60px', display: 'flex', gap: '12px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
        <button className="global-button-white" onClick={handleBack} style={{ width: '180px' }}>Zurück</button>
        <button className="global-button" onClick={handleContinue} disabled={!isFormValid()} style={{ width: '180px' }}>Weiter</button>
      </div>
    </div>
  );
}
